<div id="wrapper">
    <topnavbar></topnavbar> <app-navigation></app-navigation>
    <div id="page-wrapper" class="d-flex flex-column">
        <div class="page-main"><router-outlet></router-outlet></div>
        <!-- <footer></footer> -->
    </div>
</div>

<dx-load-panel
    #loadPanel
    message="Please wait..."
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: window }"
    [visible]="pleaseWait()"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
    >
</dx-load-panel>
